import React from 'react';

// Construye la lista de páginas a mostrar (con "…" cuando hay huecos),
// siempre con la 1ª y la última visibles — igual que el paginado de
// StelOrder. Ej: página 5 de 20 → [1, '…', 4, 5, 6, '…', 20].
export function listaPaginas(page, totalPages) {
  const rango = [];
  for (let i = Math.max(2, page - 1); i <= Math.min(totalPages - 1, page + 1); i++) rango.push(i);
  const lista = [1];
  if (rango[0] > 2) lista.push('…');
  lista.push(...rango);
  if (rango[rango.length - 1] < totalPages - 1) lista.push('…');
  if (totalPages > 1) lista.push(totalPages);
  return lista;
}

// Paginación con flechas + números al estilo StelOrder — ir directo a la
// página 1, 3, la que haga falta, no solo "ver más". `compact` la encoge
// para caber en una columna de Kanban (sin números intermedios, solo
// «‹ x/y ›»). Extraído de OrdenesView.js para que Almacén (y cualquier
// otra tabla paginada al estilo StelOrder) lo reutilice sin duplicarlo.
export default function Paginacion({ page, totalPages, onChange, compact }) {
  if (totalPages <= 1) return null;
  if (compact) {
    return (
      <div className="flex items-center justify-center gap-1.5 pt-2 text-[11px] text-gray-500">
        <button onClick={() => onChange(page - 1)} disabled={page === 1}
          className="w-5 h-5 flex items-center justify-center rounded hover:bg-gray-100 disabled:opacity-30 disabled:hover:bg-transparent">‹</button>
        <span className="font-semibold tabular-nums">{page}/{totalPages}</span>
        <button onClick={() => onChange(page + 1)} disabled={page === totalPages}
          className="w-5 h-5 flex items-center justify-center rounded hover:bg-gray-100 disabled:opacity-30 disabled:hover:bg-transparent">›</button>
      </div>
    );
  }
  return (
    <div className="flex items-center justify-center gap-1 py-3 border-t border-gray-50">
      <button onClick={() => onChange(page - 1)} disabled={page === 1}
        className="w-7 h-7 flex items-center justify-center rounded-lg text-sm font-bold text-gray-500 hover:bg-gray-100 disabled:opacity-30 disabled:hover:bg-transparent">‹</button>
      {listaPaginas(page, totalPages).map((p, i) => p === '…'
        ? <span key={`e${i}`} className="w-7 h-7 flex items-center justify-center text-xs text-gray-300">…</span>
        : (
          <button key={p} onClick={() => onChange(p)}
            className={`w-7 h-7 flex items-center justify-center rounded-lg text-xs font-bold tabular-nums transition-colors ${
              p === page ? 'bg-red-600 text-white' : 'text-gray-600 hover:bg-gray-100'
            }`}
          >{p}</button>
        )
      )}
      <button onClick={() => onChange(page + 1)} disabled={page === totalPages}
        className="w-7 h-7 flex items-center justify-center rounded-lg text-sm font-bold text-gray-500 hover:bg-gray-100 disabled:opacity-30 disabled:hover:bg-transparent">›</button>
    </div>
  );
}
